export function randomStringIdGenerator(length = 5) {
    return Math.floor((1 + Math.random()) * Math.pow(10, length))
        .toString(16)
        .substring(1);
}